import { IncognitoCircleOffIcon } from './IncognitoCircleOffIcon';

/**
 * author: Michael Irigoyen
 * id 3F362E64-C60F-416B-834D-E5C2A88ED23F
 * name incognito-circle-off
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/incognito-circle-off.svg
 * tags
 */
export const SpyCircleOffIcon = IncognitoCircleOffIcon;
export default SpyCircleOffIcon